import { Skeleton } from '@common/components';
import { cn } from '@core/utils';

export const RecentOrderGiftListItemLoading = () => {
  return (
    <li
      className={cn(
        'w-352 flex items-center gap-20',
        'mobile-tablet:w-[20.9375rem] mobile-tablet:justify-start mobile-tablet:gap-16 mobile-tablet:pr-32',
      )}
    >
      <Skeleton
        className={cn(
          'size-140 rounded-xlarge object-cover',
          'mobile-tablet:size-104',
        )}
      />
      <div className="flex grow flex-col gap-16">
        <Skeleton className="w-1/3" />
        <Skeleton className="w-2/3" />
        <Skeleton className="w-full" />
        <Skeleton className="w-full" />
      </div>
    </li>
  );
};
